<template>
    <div>
        <temp :isEdit="false"></temp>
    </div>
</template>

<script>
    import temp from './temp.vue';
    export default{
        components: {
            temp
        }
    }
</script>